import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import { portfolioFilesQuery, PortfolioFilesQueryResult } from './queries/portfolioFilesQuery';

type PortfolioFilesQueryParams = { customerId: string };

const portfolioFilesGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        portfolioFiles: builder.query<PortfolioFilesQueryResult['portfolio']['getPortfolioOverview'], PortfolioFilesQueryParams>({
            query: params => ({
                body: portfolioFilesQuery,
                variables: { customerId: params.customerId },
            }),
            transformResponse: response => response.portfolio.getPortfolioOverview,
            providesTags: (_result, _error, arg) => [{ type: 'customer', id: arg.customerId }],
        }),
    }),
});

export const { usePortfolioFilesQuery } = portfolioFilesGraphSlice;

export default portfolioFilesGraphSlice;
